/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {Login} from './components/Login'
import {ForgotPassword} from './components/ForgotPassword'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import clsx from 'clsx'

const AuthPage = () => {
  const STATE_LOGIN = 'LOGIN'
  const STATE_FORGOT = 'FORGOT'
  const [authState, setAuthState] = useState(STATE_LOGIN)

  useEffect(() => {
    document.body.classList.add('bg-body')
    return () => {
      document.body.classList.remove('bg-body')
    }
  }, [])

  const Outlet = () => {
    const handleChildData = (data: string) => {
      setAuthState(data)
    }

    if (authState === STATE_FORGOT) {
      window.history.pushState(null, '', 'forgot-password')
      return <ForgotPassword authState={handleChildData} />
    }

    if (authState === STATE_LOGIN) window.history.pushState(null, '', '/')
    return <Login authState={handleChildData} />
  }

  return (
    <div
      className='d-flex flex-column flex-column-fluid auth-layout-wrapper'
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/auth/auth-page-background.jpg')})`,
      }}
    >
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        <div
          className={clsx('w-lg-500px bg-body rounded shadow-sm p-10 p-lg-15 mx-auto auth-outlet-wrapper')}
        >
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export {AuthPage}
